import { composeClassNames, universalEach } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import { ListGroup } from "react-bootstrap";
import Heading from "src/components/Heading";
import Translate from "src/components/Translate";
import constants from "src/constants";
import gutter from "src/functions/gutter";
import translate from "src/functions/translate";
import { sInstructorRates } from "src/styles/sInstructorRates.module.scss";
import { sListGroupTable } from "src/styles/sListGroupTable.module.scss";
import { ApiRate } from "src/types/ApiRate";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  data: ApiRate[];
};

function InstructorRates({ style, className, data }: Props) {
  const { locale: lang } = useRouter();
  return constants.Show.instructorRates && data && data.length > 0 ? (
    data[0].value ? (
      <div
        className={composeClassNames([sInstructorRates, className])}
        style={style}
      >
        <div
          className={composeClassNames([sListGroupTable, "list-group-table"])}
        >
          <Heading
            type={`h3`}
            style={gutter(`margin`, `vertical`, `md`)}
            title={<Translate tKey={`Instructor prices`} />}
          />
          <ListGroup horizontal={true} className={`list-header`}>
            <ListGroup.Item variant={`primary`}>
              <Translate tKey={`Subject`} />
            </ListGroup.Item>
            <ListGroup.Item variant={`primary`}>
              <Translate tKey={`Price`} />
            </ListGroup.Item>
          </ListGroup>
          {universalEach(data, (item, i) => {
            return (
              <ListGroup horizontal={true} key={i} className={`list-item`}>
                {item.label ? (
                  <ListGroup.Item>{item.label}</ListGroup.Item>
                ) : null}
                <ListGroup.Item>
                  {String(item.value) +
                    ` ` +
                    translate(item.currency, lang) +
                    ` ` +
                    translate(
                      (function () {
                        switch (item.unit) {
                          case `minutes_15`:
                            return `per 15 minutes`;
                          case `minutes_20`:
                            return `per 20 minutes`;
                          case `minutes_30`:
                            return `per 30 minutes`;
                          case `minutes_40`:
                            return `per 40 minutes`;
                          case `minutes_45`:
                            return `per 45 minutes`;
                          case `hours_1`:
                            return `per hour`;
                          case `hours_1_15`:
                            return `per hour and quarter`;
                          case `hours_1_30`:
                            return `per hour and half`;
                          case `hours_2`:
                            return `per two hours`;
                          case `hours_2_30`:
                            return `per two hours and half`;
                          case `hours_3`:
                            return `per three hours`;
                          case `hours_4`:
                            return `per half day`;
                          case `hours_5`:
                            return `per five hours`;
                          case `hours_6`:
                            return `per six hours`;
                          case `hours_7`:
                            return `per seven hours`;
                          case `days_1`:
                            return `per day`;
                          case `days_2`:
                            return `per two days`;
                          case `days_3`:
                            return `per three days`;
                          case `days_4`:
                            return `per three days`;
                          case `days_5`:
                            return `per three days`;
                          case `days_6`:
                            return `per three days`;
                          case `weekend`:
                            return `per weekend`;
                          case `weeks_1`:
                            return `per week`;
                          case `weeks_2`:
                            return `per two weeks`;
                          case `weeks_3`:
                            return `per three weeks`;
                          case `months_1`:
                            return `per month`;
                          case `months_2`:
                            return `per two months`;
                          case `months_3`:
                            return `per three months`;
                          default:
                            return `per hour`;
                        }
                      })(),
                      lang
                    )}
                </ListGroup.Item>
              </ListGroup>
            );
          })}
        </div>
      </div>
    ) : null
  ) : null;
}

export default InstructorRates;
